import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective, ToastService, UploadFile } from 'ng-uikit-pro-standard';
import { MasivoService } from 'src/app/services/masivo.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { TiposMasivos } from 'src/app/shared/object/masivo.type';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-carga-masiva',
  templateUrl: './modal-carga-masiva.component.html',
  styleUrls: ['./modal-carga-masiva.component.scss']
})
export class ModalCargaMasivaComponent implements OnInit {
  @ViewChild('agregarMasivos', { static: true }) cargaMasivaModal: ModalDirective;
  
  file: UploadFile;
  accept: string;
  uploadForm: FormGroup;
  listaResult: any[];
  typeAlert: string;
  tipo: TiposMasivos;
  urlDownloadPlantilla: string;
  nombrePlantilla: string;

  // Utils
  private log: any
  isLoading: boolean;
  viewErrorTable: boolean;
  procesadoFinalizado: boolean;
  agregados: number;

  // TIPOS LISTAS
  listaClientes: any[];
  listaMaquinas: any[];

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastService: ToastService,
    private accesoLocalStorage: SecurityService,
    private masivoService: MasivoService,
  ) {
    this.isLoading = false;
    this.viewErrorTable = false;
    this.procesadoFinalizado = false;
    this.agregados = 0;
    this.accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
    this.typeAlert = 'alert-info';

    this.listaResult = [];
    this.listaClientes = [];
    this.listaMaquinas = [];

    this.log = this.clog.log('CARGA MASIVA')
  }

  ngOnInit() {
  }

  show(tipo: TiposMasivos) {
    this.clearData()
    this.createForms();
    this.tipo = tipo;
    this.cargaMasivaModal.show();
    this.crearURLDownloadPlantilla();
    console.log('URL PLANTILLA', this.urlDownloadPlantilla);
  }

  closeModal(){
    this.clearData();
    this.viewErrorTable = false;
    this.procesadoFinalizado = false;
    this.agregados = 0;
    this.uploadForm.reset();
  }

  private createForms() {
    const rutEmpresa = this.accesoLocalStorage.getRutEmpresa();
    const rutUsuario = this.accesoLocalStorage.getRutUsuario();
    const sucursal = this.accesoLocalStorage.getSucursalCodigo();
    this.uploadForm = this.fb.group({
      file: [null],
      rutUsuario: [rutUsuario],
      rutEmpresa: [rutEmpresa],
      sucursal: [sucursal],
    });
  }

  clearData() {
    this.isLoading = false
    this.file = null
  }

  onFileSelect(event) {
    this.log('onUploadOutput', event)

    if (event.target.files.length > 0) {
      this.log('onUploadOutputssss', event.target.files[0])

      this.file = event.target.files[0];
      this.uploadForm.get('file').setValue(this.file);
    }
    this.showFiles();
    this.log('UploadForm', this.uploadForm.value);
  }

  showFiles() {
    return this.file ? this.file.name : ''
  }

  // Lógica para procesar el archivo
  procesarArchivo() {
    this.viewErrorTable = false;
    this.procesadoFinalizado = false;
    this.isLoading = true
    if (this.file) {
      const formData = new FormData();
      formData.append("file", this.uploadForm.get("file").value);
      formData.append("rutUsuario", this.uploadForm.get("rutUsuario").value);
      formData.append("rutEmpresa", this.uploadForm.get("rutEmpresa").value);
      formData.append("sucursal", this.uploadForm.get("sucursal").value);
      formData.append("tipo", this.tipo);

      this.masivoService.cargarMasivos(formData).subscribe(x => {
        this.procesadoFinalizado = true;
        if (!x.lista) {
          this.toastService.error(x.message, 'Error de carga', { timeOut: 10000 });
          this.isLoading = false;
          return;
        }
        this.listaResult = x.lista;

        this.procesarResultadosPorTipo();

        // console.log(this.listaClientes, this.listaMaquinas);

        this.typeAlert = this.agregados == 0 ? 'alert-danger' : 
          this.agregados > 0 && this.agregados < this.listaResult.length ? 'alert-warning' :
          'alert-success';
        this.clearData();
      }, error => {
        this.log('Error cargarMasivos', error);
        this.procesadoFinalizado = false;
        this.typeAlert = 'alert-danger';
        if (error.error) {
          this.toastService.error(
            error.error.message,
            'Error de carga',
            { timeOut: 10000 }
          );          
        }else{
          this.toastService.error(
            'Hubo un problema al procesar el archivo. Por favor, inténtelo de nuevo. Si el problema continúa, comuníquese con soporte.',
            'Error innesperado',
            { timeOut: 10000 }
          );
        }
        this.clearData();
      });
    }else {
      this.toastService.error(
        'No se ha cargado ningun archivo. Seleccione un archivo para procesar.',
        'Error de archivo',
        { timeOut: 10000 }
      )
      this.isLoading = false;
    }
  }

  procesarResultadosPorTipo(){
    switch (this.tipo) {
      case 'CLIENTE':
        this.listaClientes = this.listaResult;
        this.viewErrorTable = this.listaResult.some(x => !x.agregar || !x.clienteAgregado);
        this.agregados = this.listaResult.filter(x => x.agregar && x.clienteAgregado).length;
        break;
      case 'MAQUINA':
        this.listaMaquinas = this.listaResult;
        this.viewErrorTable = this.listaResult.some(x => !x.agregar || !x.maquinaAgregada);
        this.agregados = this.listaResult.filter(x => x.agregar && x.maquinaAgregada).length;
        break;
      default:
        this.toastService.error('Hubo un error innesperado.', 'Error innesperado', { timeOut: 100000 });
        this.clog.log('Hubo un error al procesar el tipo / entidad a procesar.', this.tipo);
        break;
    }
  }

  crearURLDownloadPlantilla() {
    switch (this.tipo) {
      case 'CLIENTE':
        this.nombrePlantilla = '/formato_maestro_clientes.xlsx';
        this.urlDownloadPlantilla = environment.PLANTILLAS_URL + this.nombrePlantilla;
        break;
      case 'MAQUINA':
        this.nombrePlantilla = '/formato_maestro_maquinas.xlsx';
        this.urlDownloadPlantilla = environment.PLANTILLAS_URL + this.nombrePlantilla;
        break;
      default:
        this.nombrePlantilla = '#';
        this.urlDownloadPlantilla = environment.PLANTILLAS_URL + this.nombrePlantilla;
        break;
    }
  }
  
}
